function ellipsise(str: string, maxLength: number): string {
  if (str.length <= maxLength) {
    return str
  }

  if (maxLength <= 3) {
    // Edge case: if maxLength is very small, show only ellipsis portion
    return '.'.repeat(maxLength)
  }

  return str.slice(0, maxLength - 3) + '...'
}

function ellipsisWalletAddress(str: string, maxLength: number): string {
  if (str.length <= maxLength) {
    return str
  }

  return str.slice(0, maxLength - 10) + '...' + str.slice(str.length - 10)
}

export { ellipsise, ellipsisWalletAddress }
